import { t } from "ttag";

import { DocumentUploads } from "@/app/components/legacy-components";
import { DOCUMENT_FOLDER } from "@/shared/models/legacy-constants";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Dialog, TestTubeIcon } from "@/shared/ui";

export const LabUploadsModal = ({ show, onClose }: ModalProps) => {
  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={TestTubeIcon}>
          <Dialog.Title>{t`Add lab test`}</Dialog.Title>

          <Dialog.Description>{t`Upload your lab tests!`}</Dialog.Description>
        </Dialog.Header>

        <DocumentUploads
          folder={DOCUMENT_FOLDER.LABS}
          onCancel={onClose}
          onSuccess={onClose}
        />
      </Dialog.Content>
    </Dialog.Root>
  );
};
